import Payload from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-form/classes/Payload';

export default async (context:any, payload:any) => {
    const targetState = context.rootState[payload.targetId];
    // If form has errors (from validateForm action) then do not proceed
    if (targetState.errors.length) {
        return false;
    }

    context.commit('setAttribute', {
        id       : payload.sourceId,
        attribute: 'isLoading',
        value    : true,
    }, { root: true });

    const data = context.rootState.appState.formData;
    const agrcPayload = new Payload(
        data.complaint,
        data.employer,
        data.documents,
        data.contact,
        data.attestation,
    );

    const config = payload.oneLni.environment.current.alisService;
    const endpoint = `${ config.domain }/ALiSService/api/Complaint/SaveComplaint`;
    const response = await fetch(endpoint, {
        method : 'POST',
        headers: {
            'Content-type': 'application/json',

            'api_key': config.apiKey,
        },
        body: JSON.stringify(agrcPayload),
    });
    const result = await response.json();
    if (result.ComplaintNumber) {
        context.commit('appState/SET_VALUE', {
            key  : 'complaintNumber',
            value: result.ComplaintNumber,
        }, { root: true });

        payload.router.push('/confirmation');
    }

    context.commit('setAttribute', {
        id       : payload.sourceId,
        attribute: 'isLoading',
        value    : false,
    }, { root: true });
    // TODO: Error handling
};